'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Content } from '@radix-ui/react-accordion';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const AccordionContent = forwardRef(({ className, children, ...props }, ref) => (_jsx(Content, { ref: ref, className: "overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down", ...props, children: _jsx("div", { className: cn('select-none px-6 pb-5 text-body-3 font-normal text-metal-600 dark:text-metal-300', className), children: children }) })));
AccordionContent.displayName = Content.displayName;
export { AccordionContent };
